<template>
    <div class="user-detail-layout">
        <!-- 修改帳號信息相關 -->
        <div class="user-detail-info">
            <a-card :title="$t(`moduleTitles.${$route.meta.title}`)" :bordered="false">
                <a-row>
                    <a-col :span="12">
                        <a-form-model
                                layout="vertical"
                                ref="ruleForm"
                                :form="teamInfo"
                                :rules="rules"
                                :model="teamInfo"
                        >
                            <!-- 公司名稱 -->
                            <a-form-model-item
                                    has-feedback
                                    :label="$t('table.teamUser.info.name.label')+'：'"
                                    prop="name"
                            >
                                <a-input v-model="teamInfo.name" :placeholder="$t('table.teamUser.info.name.placeholder')" :disabled="disabled"/>
                            </a-form-model-item>
                            <!-- 公司聯係電話 -->
                            <a-form-model-item
                                    has-feedback
                                    :label="$t('table.teamUser.info.phone.label')+'：'"
                                    prop="phone"
                            >
                                <a-input v-model="teamInfo.phone" :placeholder="$t('table.teamUser.info.phone.placeholder')" :disabled="disabled"/>
                            </a-form-model-item>
                            <!-- 地址 -->
                            <a-form-model-item
                                    has-feedback
                                    :label="$t('table.teamUser.info.address.label')+'：'"
                                    prop="address"
                            >
                                <a-input v-model="teamInfo.address" :placeholder="$t('table.teamUser.info.address.placeholder')" :disabled="disabled"/>
                            </a-form-model-item>
                            <!-- 保存按鈕 -->
                            <a-form-model-item v-if="!disabled">
                                <a-button type="primary" @click="handleSubmit">{{$t('actionTitles.submit')}}</a-button>
                            </a-form-model-item>
                        </a-form-model>
                    </a-col>
                    <!--右側頭像-->
                    <a-col :span="12">
                        <div style="text-align: center;">
                            <div class="avatar">
                                <img
                                        :src="teamInfo.logo?teamInfo.logo:avatar"
                                        width="100%"
                                        height="100%"
                                        alt="avatar"
                                />
                            </div>
                            <DragUploader ref="uploader" uptype="avatar" :callback="getUploader" v-if="!disabled">
                                <a-button type="primary" slot="body">{{$t('actionTitles.avatarUpload')}}</a-button>
                            </DragUploader>
                        </div>
                    </a-col>
                </a-row>
            </a-card>
        </div>
    </div>
</template>

<script>
    import DragUploader from "@/components/DragUploader";
    import {getTeamUser,editTeamInfo} from "@/api/team";
    import {mapState} from "vuex";
    export default {
        name: "Info",
        components:{
            DragUploader
        },
        data(){
            return{
                avatar: require('@/assets/default_h.jpg'),
                teamInfo: {},
                team_id: 0,
                rules:{
                    name: [
                        {
                            required: true,
                            message: this.$t('table.teamUser.info.name.message'),
                            trigger: "blur",
                        },
                    ],
                    phone: [
                        {
                            required: true,
                            message: this.$t('table.teamUser.info.phone.message'),
                            trigger: "blur",
                        },
                    ],
                    address: [
                        {
                            required: true,
                            message: this.$t('table.teamUser.info.address.message'),
                            trigger: "blur",
                        },
                    ],
                }
            }
        },
        computed:{
            ...mapState({
                userInfo: (state) => state.user.userInfo,
            }),
            disabled(){
                return this.userInfo.is_team_admin === 1 ? false : true
            }
        },
        mounted() {
            this.team_id = Number(this.userInfo.team_id)
            this.loadData()
        },
        methods:{
            //獲取團隊成員信息
            loadData(){
                getTeamUser({team_id: this.team_id}).then(res=>{
                    if(res.code == 1){
                        console.log(res.data)
                        this.teamInfo = res.data.team_info
                    }
                }).catch(err=>{
                    console.log(err)
                })
            },
            //回調方法，up為上傳實例對像
            getUploader: function (up) {
                let _this = this;
                _this.$nextTick(() => {
                    up.bind("UploadComplete", function (up, file) {
                        _this.teamInfo.logo = _this.$refs.uploader.fileList[0].url;
                    });
                });
            },
            //保存
            handleSubmit(){
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        editTeamInfo(this.teamInfo).then(res=>{
                            this.$message.success(res.message,1)
                        }).catch(err=>{
                            console.log(err)
                        })
                    }
                });
            }
        }
    }
</script>

<style lang="less" scoped>
    .avatar {
        margin-bottom: 25px;
        img {
            border-radius: 50%;
            width: 167px;
            height: 167px;
        }
    }
</style>